import { api } from "@/lib/api";

const base = "/api/additional-revenue";

export type AdditionalRevenuePaymentStatus = "UNPAID" | "PARTIALLY_PAID" | "PAID";

export type AdditionalRevenueRow = {
  id: string;
  hospitalId: string;
  revenueNumber?: string | null;
  hospitalUnit: string;
  revenueType: string;
  revenueSource?: string | null;
  description?: string | null;
  amount: number;
  invoiceNo?: string | null;
  revenueDate: string;
  serviceMonth?: string | null;
  paymentMode?: string | null;
  paymentStatus: AdditionalRevenuePaymentStatus;
  receivedAmount: number;
  receivedAt?: string | null;
  createdByName?: string | null;
  createdAt: string;
  hospital?: { id: string; name: string } | null;
};

export type AdditionalRevenueMeta = {
  paymentModes: string[];
  paymentStatuses: string[];
  hospitalUnits: string[];
};

export type CreateAdditionalRevenueBody = {
  revenueType: string;
  revenueSource?: string;
  description?: string;
  amount: number;
  invoiceNo?: string;
  revenueDate?: string;
  serviceMonth?: string;
  paymentMode?: string;
  hospitalUnit?: string;
  targetHospitalId?: string;
};

function unwrap<T>(res: { data?: { data?: T } }): T {
  return res.data?.data as T;
}

export const additionalRevenueApi = {
  meta: () => api.get(`${base}/meta`).then((r) => unwrap<AdditionalRevenueMeta>(r)),
  listLookups: (kind: "REVENUE_TYPE" | "REVENUE_SOURCE") =>
    api.get(`${base}/lookups`, { params: { kind } }).then((r) => unwrap<{ names: string[] }>(r)),
  createLookup: (body: {
    kind: "REVENUE_TYPE" | "REVENUE_SOURCE";
    name: string;
    hospitalId?: string;
    hospitalUnit?: string;
  }) => api.post(`${base}/lookups`, body).then((r) => unwrap<{ name: string }>(r)),
  list: (params?: Record<string, string>) =>
    api.get(`${base}`, { params }).then((r) => unwrap<AdditionalRevenueRow[]>(r)),
  create: (body: CreateAdditionalRevenueBody) =>
    api.post(`${base}`, body).then((r) => unwrap<AdditionalRevenueRow>(r)),
  update: (id: string, body: Partial<CreateAdditionalRevenueBody>) =>
    api.patch(`${base}/${id}`, body).then((r) => unwrap<AdditionalRevenueRow>(r)),
  markReceived: (id: string, paymentMode: string) =>
    api.post(`${base}/${id}/mark-received`, { paymentMode }).then((r) => unwrap<AdditionalRevenueRow>(r)),
  unmarkReceived: (id: string) =>
    api.post(`${base}/${id}/unmark-received`).then((r) => unwrap<AdditionalRevenueRow>(r)),
  remove: (id: string) => api.delete(`${base}/${id}`).then((r) => unwrap<{ id: string }>(r)),
};
